import { render } from "./JobBoard.vue?vue&type=template&id=345e6284&scoped=true"
import script from "./JobBoard.vue?vue&type=script&lang=js"
export * from "./JobBoard.vue?vue&type=script&lang=js"

import "./JobBoard.vue?vue&type=style&index=0&id=345e6284&scoped=true&lang=css"
import "./JobBoard.vue?vue&type=style&index=1&id=345e6284&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345e6284"]])

export default __exports__